import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup } from "reactstrap";

const CandidateStepForm = ({ isOpen, onClose, onSave, step = null }) => {
  const [stepData, setStepData] = useState({ name: "" });

  useEffect(() => {
    setStepData({ name: step?.name || "" });
  }, [step]);

  const handleChange = (e) => {
    setStepData({ ...stepData, name: e.target.value });
  };

  const handleSubmit = () => {
    onSave(stepData, step?.id);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalHeader toggle={onClose}>{step ? "Editar Paso" : "Agregar Paso"}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="name">Nombre</Label>
          <Input id="name" name="name" type="text" value={stepData.name} onChange={handleChange} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit}>Guardar</Button>
        <Button color="danger" onClick={onClose}>Cancelar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default CandidateStepForm;
